import React, { useState } from 'react';

import { Alert, Button, Form, InputGroup, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import RegisterStepper from './RegisterStepper';
import Dot from '../../../assets/svg/Dot';
import { EyeIcon, EyeSlashIcon } from '../../../assets/svg/Eye';
import ModalCGU from '../../../common/components/ModalCGU';
import ModalPolicy from '../../../common/components/ModalPolicy';

interface IProps {
  error: string;
  handleSubmitBegin: (event: any) => void;
  validatedBegin: boolean;
  setValidatedBegin: React.Dispatch<React.SetStateAction<boolean>>;
  passwordVisibility: boolean;
  setPasswordVisibility: React.Dispatch<React.SetStateAction<boolean>>;
}

const Begin = (props: IProps) => {
  //if(checkCGUModal === true && checkPolicyModal === true) setCheckAll(true)
  //else setCheckAll(false)

  const [showCGUModal, setShowCGUModal] = useState(false);
  const [checkCGUModal, setCheckCGUModal] = useState(false);
  const [showPolicyModal, setShowPolicyModal] = useState(false);
  const [checkPolicyModal, setCheckPolicyModal] = useState(false);

  const [passwordUpperCase, setPasswordUpperCase] = useState(false);
  const [passwordLowerCase, setPasswordLowerCase] = useState(false);
  const [passwordNumber, setPasswordNumber] = useState(false);
  const [passwordLength, setPasswordLength] = useState(false);

  const checkPasswordForce = (e: any) => {
    setPasswordUpperCase(/[A-Z]/.test(e.target.value));
    setPasswordLowerCase(/[a-z]/.test(e.target.value));
    setPasswordLength(e.target.value.length >= 8);
    setPasswordNumber(/[0-9]/.test(e.target.value));
  };

  const [checkAll, setCheckAll] = useState(false);
  const changeCheckAll = (value: boolean) => {
    if (value === true && (checkCGUModal === true || checkPolicyModal === true) && checkAll === false) {
      setCheckAll(true);
      setCheckCGUModal(true);
      setCheckPolicyModal(true);
    } else if (value === false && checkAll === true) {
      setCheckAll(false);
      setCheckCGUModal(false);
      setCheckPolicyModal(false);
    }
  };

  return (
    <>
      <Row className="align-items-center justify-content-center">
        <h2 className="text-center mb-0 fw-bold register-title">C'est parti !</h2>
        <h3 className="text-center mb-4 fw-bold register-subtitle">Créer un compte dwell</h3>

        <Form
          className="register-form"
          noValidate={true}
          onSubmit={props.handleSubmitBegin}
          validated={props.validatedBegin}
          onChange={(e) => props.setValidatedBegin(e.currentTarget.checkValidity())}
        >
          {/*validated={validatedBegin} onChange={(e) => setValidatedBegin(e.currentTarget.checkValidity())}*/}
          <RegisterStepper step={0} />
          <Form.Group className="mt-4 mb-4" controlId="email">
            <Form.Control type="email" placeholder="E-mail professionel" autoComplete="username" required />
            {/*value={mailValue} onChange={(e) => setMailValue(e.target.value)}*/}
            <Form.Control.Feedback type="invalid">Veuillez choisir un nom de domaine différent.</Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-2" controlId="password">
            <InputGroup className="d-flex flex-row justify-content-start mb-3">
              <Form.Control
                pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{8,}"
                className="mr-2"
                type={props.passwordVisibility ? 'text' : 'password'}
                placeholder="Mot de passe"
                required
                onChange={checkPasswordForce}
                autoComplete="new-password"
              />
              {/*value={passwordValue} onChange={(e) => setPasswordValue(e.target.value)}*/}
              <Button
                variant="primary"
                className="btnRatioSquare"
                onClick={() => props.setPasswordVisibility(!props.passwordVisibility)}
              >
                {props.passwordVisibility ? <EyeSlashIcon /> : <EyeIcon />}
              </Button>
            </InputGroup>
          </Form.Group>
          <Form.Group className="mb-4" controlId="passwordFeedback">
            <p className="text-center mb-0 mt-0 register-info-link">Le mot de passe doit contenir au moins...</p>
            <div className="d-flex flex-row justify-content-evenly mt-0">
              <div className="d-flex flex-column justify-content-start">
                <p className="register-info mb-0">
                  <Dot color={passwordUpperCase ? ' #641abf ' : ' grey '} /> Une majuscule
                </p>
                <p className="register-info mt-0">
                  <Dot color={passwordLowerCase ? ' #641abf ' : ' grey '} /> Une minuscule
                </p>
              </div>
              <div className="d-flex flex-column justify-content-start">
                <p className="register-info mb-0">
                  <Dot color={passwordNumber ? ' #641abf ' : ' grey '} /> Un chiffre
                </p>
                <p className="register-info mt-0">
                  <Dot color={passwordLength ? ' #641abf ' : ' grey '} /> 8 caractères
                </p>
              </div>
            </div>
          </Form.Group>
          <Form.Group className="mb-3 d-flex" controlId="cgu">
            <Form.Check
              className="text"
              type="checkbox"
              required
              checked={checkAll}
              onChange={() => {
                setCheckAll(!checkAll);
                changeCheckAll(!checkAll);
              }}
            />
            <p className="text ps-3">
              J'ai lu et j'accepte les
              <span className="link register-policies">
                <strong onClick={() => setShowCGUModal(true)}> Conditions Générales d'Utilisation (CGU)</strong>
              </span>
              et la
              <span className="link register-policies">
                <strong onClick={() => setShowPolicyModal(true)}> Politique de Confidentialité</strong>
              </span>
              .
            </p>
          </Form.Group>
          {props.error !== '' && <Alert variant="danger">{props.error}</Alert>}
          <div className="text-center mb-1">
            <Button className="mt-0 mb-0 btn-register w-100" variant="primary" type="submit">
              {/* disabled={!props.validatedBegin} */}
              S'inscrire
            </Button>
          </div>
          <div className="register-info2 text-decoration-none text-center mb-5">
            <p className="register-info-link">
              Vous avez déjà un compte ?
              <Link to="login" className="register-info2 text-decoration-none link fw-bold">
                Connectez-vous
              </Link>
            </p>
          </div>
          <div className="mt-2 register-info2 text-center">
            En créant votre compte, vous acceptez que Dwell et ses partenaires traitent vos informations pour vous
            fournir différents services.
            <Link to="RGPD" className="register-info2 text-decoration-none link register-info-small-link">
              En savoir plus
            </Link>
            sur la gestion de vos données et vos droits.
          </div>
        </Form>
      </Row>

      <ModalCGU
        show={showCGUModal}
        setShow={setShowCGUModal}
        checkCGU={checkCGUModal}
        setCheckCGU={setCheckCGUModal}
        changeCheckAll={changeCheckAll}
      />
      <ModalPolicy
        show={showPolicyModal}
        setShow={setShowPolicyModal}
        checkPolicy={checkPolicyModal}
        setCheckPolicy={setCheckPolicyModal}
        changeCheckAll={changeCheckAll}
      />
    </>
  );
};
export default Begin;
